module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/sweatshirt/3-4d70b57e3ab5d7bf29c17b5ff2b89f57.jpg";